export default  function lazy(){
	console.log('should lazy')


	
		
}